import { Box, Flex, Text, Button } from '@skin-seoul/design-system';
import { ReviewWriteForm } from './ReviewWriteForm';
import { ChevronIcon } from '../assets/icons/ChevronIcon';
import { CompleteView } from './common/CompleteView';
import BottomSheet from './common/BottomSheet';
import { COLORS, FONT_SIZES, FONT_WEIGHTS, SPACING, Z_INDEX, BREAKPOINTS } from './common/constants';
import { useReviewForm } from '../hooks/useReviewForm';
import { useReviewModalState } from '../hooks/useReviewModalState';
import { useReviewSubmission } from '../hooks/useReviewSubmission';
import type { ReviewModalProps } from './common/interfaces';

export const ReviewWriteMobileModal = ({ isOpen, productImage, onClose, onSubmit }: ReviewModalProps) => {
  const { formState, formActions, formOptions, isSubmitDisabled, resetForm } = useReviewForm({ isOpen });

  const { isComplete, setIsComplete, handleClose } = useReviewModalState({
    isOpen,
    onClose: () => {
      resetForm();
      onClose();
    },
    hasUnsavedChanges: false,
    enableConfirmation: false,
  });

  const { handleSubmit } = useReviewSubmission({
    formData: formState,
    onSubmit,
    onSubmissionComplete: () => setIsComplete(true),
  });

  if (!isOpen) {
    return null;
  }

  return (
    <>
      {!isComplete && (
        <Box
          position="fixed"
          top="0"
          left="0"
          right="0"
          bottom="0"
          zIndex={Z_INDEX.mobileModal}
          bg={COLORS.background}
          display="flex"
          flexDirection="column"
          css={{
            [`@media (min-width: ${BREAKPOINTS.mobile})`]: {
              display: 'none',
            },
          }}
        >
          <Flex
            h="66px"
            align="center"
            justify="flex-start"
            position="relative"
            bg={COLORS.background}
            p={`${SPACING.xl} ${SPACING.lg} ${SPACING.sm} ${SPACING.lg}`}
            boxSizing="border-box"
            gap={SPACING.lg}
          >
            <Button
              border="none"
              style={{ fontSize: '28px' }}
              color="#333"
              cursor="pointer"
              borderRadius="30px"
              p={SPACING.sm}
              bg="revert"
              onClick={handleClose}
            >
              <ChevronIcon direction="left" />
            </Button>
            <Text
              color={COLORS.text}
              fontFamily="Plus Jakarta Sans"
              style={{
                fontSize: FONT_SIZES['2xl'],
                fontFeatureSettings: "'ss10' on",
                fontStyle: 'normal',
                lineHeight: '140%',
              }}
              fontWeight={FONT_WEIGHTS.normal}
            >
              Review this product
            </Text>
          </Flex>

          <Box flex="1" overflowY="auto" bg={COLORS.background} p={SPACING.lg}>
            <ReviewWriteForm
              formData={formState}
              formActions={formActions}
              options={formOptions}
              productImage={productImage}
              isSubmitDisabled={isSubmitDisabled}
              onSubmit={handleSubmit}
              variant="mobile"
            />
          </Box>
        </Box>
      )}

      {isComplete && (
        <BottomSheet isOpen={isComplete} onClose={onClose} title="">
          <CompleteView onContinue={onClose} variant="mobile" />
        </BottomSheet>
      )}
    </>
  );
};
